import React from "react"
import { Wrapper, LinkWrapper, Link } from "./styles"

const SocialNav = ({ color }) => {
  const data = [
    {
      title: "Sklep",
      url: "https://sklep.beksinski.com.pl/",
    },
    {
      title: "Fb",
      url: "https://www.facebook.com/fundacjabeksinski/",
    },
    {
      title: "Ig",
      url: "https://www.instagram.com/beksinski_foundation/",
    },
  ]
  return (
    <Wrapper>
      {data.map(({ title, url }) => (
        <LinkWrapper color={color} key={title}>
          <Link color={color} href={url}>
            {title}
          </Link>
        </LinkWrapper>
      ))}
    </Wrapper>
  )
}

export { SocialNav }
